import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';

import {
  Dietitian,
  DietitianProps,
} from '../../data/dietitian/domain/dietitian';
import { ConditionedTabAlertComponent } from './components/conditioned-tab-alert/conditioned-tab-alert.component';
import { SideBarNavigationTabs } from './components/sidebar/sidebar.model';
import { DashboardFacade, DashBoardViewModel } from './dashboard.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DashboardFacade],
})
export class DashboardComponent implements OnInit {
  private modalRef: BsModalRef;
  dashboardStatus$: Observable<DashBoardViewModel>;
  dietitian: Dietitian;

  constructor(
    private facade: DashboardFacade,
    private modalService: BsModalService,
  ) {
    this.dashboardStatus$ = this.facade.dashboardStatus$;

    this.dashboardStatus$.subscribe((status) => {
      if (!status.isLoading && status.dietitian) {
        this.dietitian = status.dietitian;
      }
    });
  }

  ngOnInit(): void {
    this.initWebNotifications().then();
  }

  async initWebNotifications() {
    if (!this.dietitian) {
      return;
    }

    try {
      const notificationToken = await this.facade.requestNotification();
      if (!notificationToken) {
        return;
      }

      if (this.dietitian.notificationToken !== notificationToken) {
        // update notification token only when different
        return this.facade.updateCurrentDietitian({
          notificationToken,
        } as DietitianProps);
      }
    } catch (e) {
      // notification was declined by user
    }
  }

  signOut(): Promise<void> {
    return this.facade.signOut();
  }

  onWrongCondition(tab: SideBarNavigationTabs) {
    if (tab === SideBarNavigationTabs.USER_GUIDE) {
      this.modalRef = this.modalService.show(ConditionedTabAlertComponent, {
        class: 'modal-lg msd-ug-alert-popup',
      });

      document
        .getElementsByClassName('modal-backdrop')[0]
        .classList.add('backdrop-black');

      this.modalRef.onHidden?.subscribe(() => {
        if (document.getElementsByClassName('modal-backdrop')[0]) {
          document
            .getElementsByClassName('modal-backdrop')[0]
            .classList.remove('backdrop-black');
        }
      });
    } else {
      // todo popup accès impossible
    }
  }
}
